import Link from "next/link";
import styles from "./StatsCard.module.css";

export enum StatVariant {
  ACTIVE = "active",
  PENDING = "pending",
  MUTED = "muted",
}

export type StatItem = {
  value: number;
  label: string;
  variant?: StatVariant;
  hidden?: boolean;
};

type Props = {
  title: string;
  link?: { href: string; label: string };
  stats: StatItem[];
};

export default function StatsCard({ title, link, stats }: Props) {
  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>{title}</span>
        {link && (
          <Link href={link.href} className={styles.cardLink}>
            {link.label} →
          </Link>
        )}
      </div>

      <div className={styles.stats}>
        {stats
          .filter((s) => !s.hidden)
          .map((stat, i) => (
            <div key={i} className={`${styles.stat} ${stat.variant ? styles[stat.variant] : ""}`}>
              <span className={styles.statValue}>{stat.value}</span>
              <span className={styles.statLabel}>{stat.label}</span>
            </div>
          ))}
      </div>
    </div>
  );
}
